import * as React from 'react';

function SvgReferralEdit(props) {
  return (
    <svg width={14} height={14} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M3.026 10.749a.63.63 0 00.094-.008l2.628-.461a.153.153 0 00.083-.044l6.623-6.623a.155.155 0 000-.22L9.858.792A.155.155 0 009.747.75a.155.155 0 00-.111.045L3.012 7.417a.159.159 0 00-.043.083l-.461 2.628a.524.524 0 00.147.466.53.53 0 00.371.155zM4.08 8.024l5.667-5.666 1.145 1.145L5.225 9.17l-1.39.245.245-1.39zm8.67 4.037H1.25a.5.5 0 00-.5.5v.563c0 .068.056.125.125.125h12.25a.125.125 0 00.125-.125v-.563a.5.5 0 00-.5-.5z"
        fill="#38B2A6"
      />
    </svg>
  );
}

export default SvgReferralEdit;
